<template>
    <div class="config-editor">
        
        <div class="sidebar">
            <div class="item" :class="{'selected': currentTab == 'general'}" v-on:click="currentTab = 'general'">
                General
            </div>
            <div class="item" :class="{'selected': currentTab == 'font'}" v-on:click="currentTab = 'font'">
                Fuente
            </div>
            <div class="item" :class="{'selected': currentTab == 'lang-config'}" v-on:click="currentTab = 'lang-config'">
                Configurar Lenguaje
            </div>
            <div class="item" :class="{'selected': currentTab == 'load-save'}" v-on:click="currentTab = 'load-save'">
                Abrir y Guardar
            </div>
        </div>
        <div class="main">
            <div class="section" v-show="currentTab == 'load-save'">
                <h1>Abrir y Guardar Configuraci&oacute;n</h1>
                <PsButton :model="'Abrir'" :icon="'fa-upload'" :icon-color="'fa-blue'" @click="openDialogLoadConfig"></PsButton>
                <PsButton :model="'Guardar'"  :icon="'fa-download'" :icon-color="'fa-green'" @click="saveConfig"></PsButton>
                <span v-show="changed" style="color: #E33">
                    Debes actualizar la p&aacute;gina para que los cambios tengan efecto.
                </span>
            </div>
            <div class="section" v-show="currentTab == 'general'">
                <h1>General</h1>
                <div class="config">
                    <label for="autocomplete">
                        <input id="autocomplete" type="checkbox" v-model="preferences.autocomplete" name="autocomplete">Autocompletado de c&oacute;digo.
                    </label>
                    <p>Al activar esta opción, se sugerir&aacute; c&oacute;digo mientras escribe.</p>
                </div>
                <div class="config">
                    <label for="case-sensitive">
                        <input id="case-sensitive" type="checkbox" v-model="preferences.caseSensitive" name="case-sensitive">Sensible a may&uacute;sculas y min&uacute;sculas.
                    </label>
                    <p>Si activa esta opción, las palabras claves deberán ser escritas respetando las mayúsculas correspondientes.</p>
                </div>
            </div>
            <div class="section" v-show="currentTab == 'font'">
                <h1>Fuente</h1>    
                <div class="config">
                    <h3>Codigo</h3>
                    <p>
                        <label for="code-font-name">
                            Fuente: 
                            <select v-model="preferences.fontCodeName">
                                <option name="code-font-name" v-for="font in fontConfig.fontList" :value="font">{{ font }}</option>
                            </select>
                        </label>
                    </p>
                    <p>
                        <label for="code-size">
                            Tamaño: <input v-model="preferences.fontCodeSize" type="text" name="code-size">
                        </label>
                    </p>
                    <p>
                        <label for="code-bold">
                            <input id="code-bold" type="checkbox" v-model="preferences.fontCodeBold" name="code-bold">Negrita
                        </label>
                        <label for="code-italic">
                            <input id="code-italic" type="checkbox" v-model="preferences.fontCodeItalic" name="code-italic">Italica
                        </label>
                    </p>
                    <h3>Pantalla</h3>
                    <p>
                        <label for="screen-font-name">
                            Fuente: 
                            <select v-model="preferences.fontScreenName">
                                <option name="screen-font-name" v-for="font in fontConfig.fontList" :value="font">{{ font }}</option>
                            </select>
                        </label>
                    </p>
                    <p>
                        <label for="screen-size">
                            Tamaño: <input v-model="preferences.fontScreenSize" type="text" name="screen-size">
                        </label>
                    </p>
                    <p>
                        <label for="screen-bold">
                            <input id="screen-bold" type="checkbox" v-model="preferences.fontScreenBold" name="screen-bold">Negrita
                        </label>
                        <label for="screen-italic">
                            <input id="screen-italic" type="checkbox" v-model="preferences.fontScreenItalic" name="screen-italic">Italica
                        </label>
                    </p>
                    <p>&nbsp;</p>
                    <PsButton :model="'Aplicar cambios'" :icon="'fa-check'" :icon-color="'fa-green'" @click="preferenceChanged"></PsButton>
                    
                </div>
            </div>
            <div class="section" v-show="currentTab == 'lang-config'">
                <h1>Configurar Lenguaje</h1>
                <p>
                    <div>
                        <input type="radio" id="lang_default" name="lang_config" value="default" v-model="configType">
                        <label for="lang_default">Sin modificaciones</label>
                    </div>
                    <div>
                        <input type="radio" id="lang_custom" name="lang_config" value="custom" v-model="configType">
                        <label for="lang_custom">Personalizar</label>
                    </div>
                </p>
                <div v-show="configType == 'custom'">
                    <p>Nombre: <input  style="max-width: 300px; margin-left: 10px;" v-model="langConfig.name" type="text" class="keyword-enter"></p>
                    <p>Configurar las palabras clave del lenguaje. Utilice comas para configurar m&aacute;s de una plabra clave por elemento.</p>
                    <table class="config-table">
                        <thead>
                            <tr>
                                <th>Elemento</th>
                                <th>Palabras clave configuradas</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Algoritmo Principal - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_PROCESS" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Algoritmo Principal - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_PROCESS" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Definir una variable - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_DEFINE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Definir una variable - Como</td>
                                <td><input v-model="langConfig.keywords.K_AS" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Definir una variable - Dimensi&oacute;n</td>
                                <td><input v-model="langConfig.keywords.K_DIMENSION" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_IF" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional - Luego de condición</td>
                                <td><input v-model="langConfig.keywords.K_THEN" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional - Alternativa</td>
                                <td><input v-model="langConfig.keywords.K_ELSE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_IF" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Para - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_FOR" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Para - Hasta</td>
                                <td><input v-model="langConfig.keywords.K_TO" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Para - Con Paso</td>
                                <td><input v-model="langConfig.keywords.K_STEP" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Para - Hacer</td>
                                <td><input v-model="langConfig.keywords.K_DO" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Para - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_FOR" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Mientras - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_WHILE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Mientras - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_WHILE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Repetir Hasta Que - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_REPEAT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Repetición Repetir Hasta Que - Fin</td>
                                <td><input v-model="langConfig.keywords.K_UNTIL" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Subalgoritmos - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_SUB_PROCESS" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Subalgoritmos - Pasaje Por</td>
                                <td><input v-model="langConfig.keywords.K_BY" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Subalgoritmos - Valor</td>
                                <td><input v-model="langConfig.keywords.K_VALUE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Subalgoritmos - Referencia</td>
                                <td><input v-model="langConfig.keywords.K_REFERENCE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Subalgoritmos - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_SUB_PROCESS" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Funciones - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_FUNCTION" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Funciones - Retorna</td>
                                <td><input v-model="langConfig.keywords.K_RETURN" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Funciones - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_FUNCTION" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional m&oacute;ltiple - Inicio</td>
                                <td><input v-model="langConfig.keywords.K_SELECT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional m&oacute;ltiple - De otro modo</td>
                                <td><input v-model="langConfig.keywords.K_OTHERWISE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Condicional m&oacute;ltiple - Fin</td>
                                <td><input v-model="langConfig.keywords.K_END_SELECT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Entrada</td>
                                <td><input v-model="langConfig.keywords.K_READ" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Salida</td>
                                <td><input v-model="langConfig.keywords.K_WRITE" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Salida Sin Saltar</td>
                                <td><input v-model="langConfig.keywords.K_WITHOUT_JUMP" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Esperar</td>
                                <td><input v-model="langConfig.keywords.K_WAIT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Esperar - Tecla</td>
                                <td><input v-model="langConfig.keywords.K_KEY" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Borrar Pantalla</td>
                                <td><input v-model="langConfig.keywords.K_CLEAR_SCREEN" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Funciones primitivas - Valor absoluto</td>
                                <td><input v-model="langConfig.keywords.K_ABS" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Funciones primitivas - Ra&iacute;z cuadrada</td>
                                <td><input v-model="langConfig.keywords.K_SQRT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Funciones primitivas - M&oacute;dulo</td>
                                <td><input v-model="langConfig.keywords.K_MOD" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Tipos - Entero</td>
                                <td><input v-model="langConfig.keywords.K_INT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Tipos - Real</td>
                                <td><input v-model="langConfig.keywords.K_FLOAT" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Tipos - L&oacute;gico</td>
                                <td><input v-model="langConfig.keywords.K_BOOL" type="text" class="keyword-enter"></td>
                            </tr>
                            <tr>
                                <td>Tipos - Caracter</td>
                                <td><input v-model="langConfig.keywords.K_CHAR" type="text" class="keyword-enter"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p>
                    <PsButton :model="'Aplicar cambios'" :icon="'fa-check'" :icon-color="'fa-green'" @click="updateConfig"></PsButton>
                    <span v-show="changed" style="color: #E33">
                        Debes actualizar la p&aacute;gina para que los cambios tengan efecto.
                    </span>
                </p>
            </div>
        </div>
        
    </div>
</template>
<script>
    import PsButton from './../Widget/PsButton'
    import { EventBus } from './../../EventBus.js'
    import { Storage } from './../../Storage.js'

    export default {
        name: 'TabConfigEditor',
        props: ['id', 'config'],
        components: {
            PsButton
        },
        created () {
            EventBus.$on('config.open', (file) => {
                this.loadConfig(file.data)
            })

            EventBus.$on('editor.fontSizeUp', () => {
                this.preferences.fontCodeSize += 2
                this.preferenceChanged()
            })

            EventBus.$on('editor.fontSizeDown', () => {
                this.preferences.fontCodeSize -= 2
                this.preferenceChanged()
            })

            EventBus.$on('screen.fontSizeUp', () => {
                this.preferences.fontScreenSize += 2
                this.preferenceChanged()
            })

            EventBus.$on('screen.fontSizeDown', () => {
                this.preferences.fontScreenSize -= 2
                this.preferenceChanged()
            })

            this.$emit('processNameChange', this.id, 'Configuración')
            this.currentConfig = window.LangConfig.getTokens()
            this.configType = window.LangConfig.isCustomLanguage() ? 'custom' : 'default'
            for (let token in this.currentConfig) {
                if (this.currentConfig[token].keywords !== undefined && Array.isArray(this.currentConfig[token].keywords)) {
                    this.langConfig.keywords[token] = this.currentConfig[token].keywords.join(', ')
                }
            }
            this.langConfig.name = window.LangConfig.getName()
            for (let prefName in this.preferences) {
                this.preferences[prefName] = Storage.getPreference(prefName, this.preferences[prefName])
            }
        },
        computed: {
        },
        beforeDestroy () {
        },
        mounted () {
        },
        watch: {
            'preferences.autocomplete' () {
                this.preferenceChanged()
            },
            'preferences.caseSensitive' () {
                this.preferenceChanged()
            }
        },
        methods: {
            downloadFile (title, content) {
                function destroyClickedElement (event) {
                    document.body.removeChild(event.target)
                }
                window.URL = window.URL || window.webkitURL
                let textFileAsBlob = new Blob([content], { type: 'text/plain' })
                let downloadLink = document.createElement('a')
                downloadLink.download = title
                downloadLink.innerHTML = 'download link'
                downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
                downloadLink.onclick = destroyClickedElement
                downloadLink.style.display = 'none'
                document.body.appendChild(downloadLink)
                downloadLink.click()
            },
            openDialogLoadConfig () {
                EventBus.$emit('config.open.dialog')
            },
            loadConfig (configString) {
                let config
                try {
                    config = JSON.parse(configString)
                    if (config.version === '0.0.1') {
                        this.loadVersion001Config(config)
                    }
                } catch (e) {
                    alert('No se pudo abrir la configuración seleccionada.')
                }
            },
            loadVersion001Config (config) {
                if (config.preferences !== undefined) {
                    for (let conf in this.preferences) {
                        if (config.preferences[conf]) {
                            this.preferences[conf] = config.preferences[conf]
                        }
                    }
                }

                this.configType = config.configType

                this.langConfig.name = config.language.name
                for (let token in config.language.keywords) {
                    this.langConfig.keywords[token] = config.language.keywords[token].join(', ')
                }

                this.updateConfig()
            },
            saveConfig () {
                let config = {
                    version: '0.0.1',
                    preferences: this.preferences,
                    configType: this.configType,
                    language: Storage.getLanguageConfig()
                }

                this.downloadFile('Configuracion psflex.json', JSON.stringify(config))
            },
            preferenceChanged () {
                for (let prefName in this.preferences) {
                    Storage.savePreference(prefName, this.preferences[prefName])
                }
                EventBus.$emit('config.preferences.changed')
            },
            updateConfig () {
                if (this.configType === 'custom') {
                    if (this.langConfig.name.trim() === '') {
                        alert('Escriba un nombre para el lenguaje')
                        return
                    }
                    let newConfig = {
                        name: this.langConfig.name,
                        keywords: {}
                    }
                    for (let keyword in this.langConfig.keywords) {
                        newConfig.keywords[keyword] = this.langConfig.keywords[keyword].split(',').map(function (element) {
                            return element.trim()
                        })
                    }
                    Storage.saveLanguageConfig(newConfig)
                    Storage.setLanguageSelection(this.configType)
                    this.changed = true
                } else {
                    Storage.saveLanguageConfig(null)
                    Storage.setLanguageSelection(this.configType)
                    this.changed = true
                }
            }
        },
        data () {
            return {
                langConfig: {
                    name: '',
                    keywords: {}
                },
                currentConfig: null,
                changed: false,
                configType: 'default',
                preferences: {
                    caseSensitive: false,
                    autocomplete: true,
                    fontScreenName: 'Inconsolata',
                    fontScreenSize: 16,
                    fontScreenBold: false,
                    fontScreenItalic: false,
                    fontCodeName: 'Inconsolata',
                    fontCodeSize: 12,
                    fontCodeBold: false,
                    fontCodeItalic: false
                },
                currentTab: 'general',
                fontConfig: {
                    fontList: ['American Typewriter', 'Andale Mono', 'Arial Black', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS', 'Arial', 'Avenir Next Condensed', 'Avenir Next', 'Avenir', 'Bahnschrift', 'Baskerville', 'Big Caslon', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bodoni 72', 'Bradley Hand', 'Brush Script MT', 'Calibri', 'Cambria Math', 'Cambria', 'Candara', 'Chalkboard SE', 'Chalkboard', 'Chalkduster', 'Charter', 'Cochin', 'Comic Sans MS', 'Consolas', 'Constantia', 'Copperplate', 'Corbel', 'Courier New', 'Courier', 'Didot', 'DIN Alternate', 'DIN Condensed', 'Ebrima', 'Franklin Gothic Medium', 'Futura', 'Gabriola', 'Gadugi', 'Geneva', 'Georgia', 'Gill Sans', 'Helvetica Neue', 'Helvetica', 'Herculanum', 'Hoefler Text', 'HoloLens MDL2 Assets', 'Impact', 'Ink Free', 'Javanese Text', 'Leelawadee UI', 'Lucida Console', 'Lucida Grande', 'Lucida Sans Unicode', 'Luminari', 'Malgun Gothic', 'Marker Felt', 'Marlett', 'Menlo', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Sans Serif', 'Microsoft Tai Le', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU-ExtB', 'Monaco', 'Mongolian Baiti', 'MS Gothic', 'MV Boli', 'Myanmar Text', 'Nirmala UI', 'Noteworthy', 'Optima', 'Palatino Linotype', 'Palatino', 'Papyrus', 'Phosphate', 'Rockwell', 'Savoye LET', 'Segoe MDL2 Assets', 'Segoe Print', 'Segoe Script', 'Segoe UI Emoji', 'Segoe UI Historic', 'Segoe UI Symbol', 'Segoe UI', 'SignPainter', 'SimSun', 'Sitka', 'Skia', 'Snell Roundhand', 'Sylfaen', 'Symbol', 'Tahoma', 'Times New Roman', 'Times', 'Trattatello', 'Trebuchet MS', 'Verdana', 'Webdings', 'Wingdings', 'Yu Gothic', 'Zapfino', 'monospace', 'sans-serif', 'Roboto', 'Inconsolata']
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .config-editor {
        padding: 10px;
        display: flex;
        flex-flow: row;
        margin-top: 40px;
    }

    .sidebar {
        width: 280px;
        margin-top: 00px;
    }
    .sidebar > .item:first-child {
    }
    .sidebar > .item {
        padding: 20px;
        margin-bottom: 10px;
        font-size: 18px;
        background-color: #F0F0F0;
        cursor: pointer;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
    }   

    .sidebar > .item:hover {
        background-color: #FFF;
    }

    .sidebar > .item.selected {
        font-weight: bold;
        
        background-color: white;
    }

    .main {
        flex: 1 100%;
        padding: 30px;
        background-color: white;
    }
    .config {
        padding-left: 20px;
        padding-right: 5px;
        padding-top: 4px;
        padding-bottom: 12px;
    }
    .config p {
        padding-left: 20px;
        margin-top: 10px;
        margin-left: 5px;

        color: #444;

    }

    .config-table {
        border: 1px solid #999;
        border-collapse: collapse;
        width: 80%;
    }
    .config-table td {
        border: 1px solid #999;
        padding: 5px;
    }
    .config-table th {
        border: 1px solid #999;
        padding: 5px;
    }
    input.keyword-enter {
        height: 18px;
        font-size: 12px;
        line-height: 18px;
        padding: 2px;
        margin: 0px;
        border: 1px solid #AAA;
        border-radius: 2px;
        width: calc(100% - 10px);
    }
</style>


// WEBPACK FOOTER //
// src/Components/ConfigEditor/ConfigEditor.vue